export default "__VITE_ASSET__DU0ilLbK__"